//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';
import { faMeSubscription } from '@motionelements/assets/src/js/me-font/icons-channels2022';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import SubscribePrice from './price/SubscribePrice.vue';
import SubscribeHeroBanner from './SubscribeHeroBanner.vue';
import SubscribeStats from './SubscribeStats.vue';

export default {
  name: 'SubscribeHero',
  props: {
    showAiLogos: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SubscribeHeroBanner,
    SubscribePrice,
    SubscribeStats,
    SubscribeHero2026Stats: () => import('@/components/subscribe2026/SubscribeHero2026Stats.vue'),
    SubscribeHeroAiCoinsCard: () => import('@/components/subscribe/SubscribeHeroAiCoinsCard.vue'),
  },
  mixins: [featureFlagMixin],
  data() {
    return {
      faCheck,
      faMeSubscription,
    };
  },
  computed: {
    subscriptionElementCount() {
      return renderContentCount(this, publishedContentCounts.total.subscription.element);
    },
  },
};
